module.exports = __webpack_public_path__ + "ac1c0cac546690efaa0788b3f67efa5e.png";